
if (!window.focusCartReviewsBound) {
  window.focusCartReviewsBound = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-review-step]');
    if (!button) return;
    const track = button.closest('.fd-cart-reviews').querySelector('.fd-cart-reviews__track');
    const cards = Array.from(track.children);
    const current = Math.round(track.scrollLeft / (cards[0].offsetWidth + 12));
    const next = (current + Number(button.dataset.reviewStep) + cards.length) % cards.length;
    track.scrollTo({left: cards[next].offsetLeft - cards[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
}
